<div class="export-buttons">
  <div class="export-buttons__list">
    @if (documentId$ | async; as documentId) {
    <a class="export-buttons__item" (click)="export('download', documentId)">
      <mat-icon>download</mat-icon>
      <p class="export-buttons__name" i18n="@@featureExport-exportButtons-download">Herunterladen (xlsx)</p>
    </a>
    @if (showForward) {
    <a class="export-buttons__item" (click)="export('mail', documentId)">
      <mat-icon>mail</mat-icon>
      <p class="export-buttons__name" i18n="@@featureExport-exportButtons-send">Weiterleiten</p>
    </a>
    } } @else { @if (status$ | async; as status) { @if (status === ExportDocumentStatus.FAILED) {
    <div class="export-buttons__failure">
      <mat-icon class="export-buttons__failure-icon">cancel</mat-icon>
      <span i18n="@@featureExport-exportButtons-documentError"
        >Das Dokument konnte nicht erstellt werden. Bitte versuchen Sie es später erneut!</span
      >
    </div>
    } @else {
    <div class="loading-animation">
      <planone-loading-animation></planone-loading-animation>
    </div>
    } } }
  </div>
</div>
<ng-template #loading>
  <div class="loading-animation">
    <planone-loading-animation></planone-loading-animation>
  </div>
</ng-template>
